// extracted by mini-css-extract-plugin
export default {"font-renta":"WarehouseAddTaskModal_font-renta__Jw1it","addTaskModal":"WarehouseAddTaskModal_addTaskModal__ZkjEq","deleteButton":"WarehouseAddTaskModal_deleteButton__L0RVZ"};